import axios from "axios";

axios.interceptors.request.use(
  (config) => {
      if( config && config.headers) {
          config.headers["Content-Encoding"] = "gzip";
      }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
